import type { ReactNode } from "react";
import type { WorkOrderDetail } from "../../../queries/useWorkOrderDetailQuery";
import {
  DetailCard,
  DetailGrid,
  Field,
  formatDate,
} from "./WorkOrderDetailLayout";

function hasValue(value: string | null) {
  return Boolean(value?.trim());
}

export function WorkOrderSourceMetadata({
  workOrder,
}: {
  workOrder: WorkOrderDetail;
}) {
  const metadata = workOrder.metadata;
  const fields: ReactNode[] = [];

  if (hasValue(metadata.createdBySource)) {
    fields.push(
      <Field
        key="createdBySource"
        label="Created by source"
        value={metadata.createdBySource}
      />,
    );
  }
  if (hasValue(metadata.requestedBySource)) {
    fields.push(
      <Field
        key="requestedBySource"
        label="Requested by source"
        value={metadata.requestedBySource}
      />,
    );
  }
  if (hasValue(metadata.revision)) {
    fields.push(
      <Field key="revision" label="Revision" value={metadata.revision} />,
    );
  }
  if (hasValue(metadata.orderSystemStatus)) {
    fields.push(
      <Field
        key="systemStatus"
        label="System status"
        value={metadata.orderSystemStatus}
      />,
    );
  }
  if (hasValue(metadata.orderUserStatus)) {
    fields.push(
      <Field
        key="userStatus"
        label="User status"
        value={metadata.orderUserStatus}
      />,
    );
  }
  if (hasValue(metadata.priorityText)) {
    fields.push(
      <Field
        key="priorityText"
        label="Priority text"
        value={metadata.priorityText}
      />,
    );
  }
  if (hasValue(metadata.latestSourceName)) {
    fields.push(
      <Field
        key="latestSource"
        label="Latest source"
        value={metadata.latestSourceName}
      />,
    );
  }
  if (metadata.latestSourceDate) {
    fields.push(
      <Field
        key="latestSourceDate"
        label="Latest source date"
        value={formatDate(metadata.latestSourceDate)}
      />,
    );
  }
  if (hasValue(metadata.sourceList)) {
    fields.push(
      <Field
        key="sourceList"
        label="Source list"
        value={metadata.sourceList}
      />,
    );
  }
  if (metadata.sourceUpdatedAt) {
    fields.push(
      <Field
        key="sourceUpdatedAt"
        label="Source updated"
        value={formatDate(metadata.sourceUpdatedAt)}
      />,
    );
  }
  if (metadata.lastSyncedAt) {
    fields.push(
      <Field
        key="lastSyncedAt"
        label="Last synced"
        value={formatDate(metadata.lastSyncedAt)}
      />,
    );
  }

  if (fields.length === 0) return null;

  return (
    <DetailCard title="Source metadata">
      <DetailGrid>{fields}</DetailGrid>
    </DetailCard>
  );
}
